import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const quadisTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.quadis,
  logoUrl: "https://cdn.nemuru.com/assets/logos/quadis-logo.svg",
  palette: {
    primary: {
      main: "#F5A400",
      contrastText: "#000",
    },
    secondary: {
      main: "#000",
      light: "#3c3b39",
      contrastText: "#FFF",
    },
    text: {
      title: "#000",
      primary: "#000",
      secondary: "#999999",
    },
    error: {
      light: "#fbefee",
      main: "#f1595c",
      contrastText: "#ffffff",
    },
    info: {
      light: "#eef5fd",
      main: "#43aeba",
      dark: "#098f9e",
      contrastText: "#ffffff",
    },
    warning: {
      light: "#fefbf3",
      main: "#f8cd51",
      dark: "#ba8f14",
      contrastText: "#353430",
    },
    success: {
      light: "#f1faf1",
      main: "#3ab56f",
      dark: "#1c8a4b",
      contrastText: "#ffffff",
    },
    // additional colors
    dark: {
      main: "#fff5ea",
      accent: "#BB7C00",
      contrastText: "#000",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#1c8135",
      approved: "#033d12",
      analysing: "#00697c",
      sent: "#0041a5",
      cancelled: "#b6b5b2",
      denied: "#f1595c",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#FCFCFC",
  customBorderRadius: {
    button: 24,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily: "at_hauss_stdregular, Helvetica, Arial, sans-serif",
  },
};
